<template>
    <v-card :loading="cardLoading">
        <v-card-title>
          {{post.title}}
        </v-card-title>
        <v-divider/>
        <v-list-item three-line>
            <v-list-item-content>
                <v-list-item-subtitle>
                  <span v-html="post.body">
                  </span>
                </v-list-item-subtitle>

            </v-list-item-content>
        </v-list-item>
        <v-divider/>
        <v-card-actions>
            <div class="caption" v-if="post.category !== undefined">
                    Category: {{post.category.name}} | Publish date : {{publishDate}}
            </div>
            <v-spacer/>
            <v-text-field
            v-if="showPriorityField"
              type="number"
              flat
              hint="Priority"
              prepend-inner-icon="mdi-counter"
              persistent-hint
              v-model="post.order"
              @keydown.enter="onPriorityChange"
              class="shrink"
            ></v-text-field >
            <v-btn
                color="primary"
                @click.stop="editNews"
                text
            >
              <v-icon>{{ icons.edit }}</v-icon>

            </v-btn>

            <v-btn
                color="primary"
                text
                :loading="loading"
                @click.stop="showDeleteDialog=true"
            >
                <v-icon>{{ icons.delete }}</v-icon>
            </v-btn>

            <DeleteDialog :data="{id:post.id,type:post.type}" :visible="showDeleteDialog" @close="showDeleteDialog=false" @confirmAction="deletingImageCallback"/>
            <PriorityConfirmDialog @continue ="priorityChangeConfirmed" :data="priorityDialogData" :visible="showPriorityDialog" @close="closePriorityDialog" />
        </v-card-actions>
    </v-card>
</template>
<script>
import DeleteDialog from '@/components/ConfirmDeleteDialog.vue'
import urlUtils from '@/utils/urlUtils'
import postApi from '@/api/postApi'
import breakingNewsApi from '@/api/breakingNewsApi'
import snackbar from '@/utils/snackbar'
import { mdiPencil, mdiDelete } from '@mdi/js'
import * as postType from '@/constants/PostType'
import PriorityConfirmDialog from '@/components/PriorityConfirmDialog.vue'
import * as dateFormats from '@/constants/dateFormats'

export default {

  components: {
    DeleteDialog,
    PriorityConfirmDialog
  },
  props: {
    post: {
      type: Object,
      required: true
    },
    showPriorityField: {
      type: Boolean,
      required: false,
      default: true
    },
    // this is needed for checking if duplicate priority value exists
    postArray: {
      type: Array,
      required: false
    }

  },
  data () {
    return {
      icons: {
        edit: mdiPencil,
        delete: mdiDelete
      },
      oldOrder: null,
      showPriorityDialog: false,

      // this is sent to server when updating prioirty
      priorityParams: {
        id: null,
        category_id: null,
        publish_date: null,
        order: null,
        sort: 'order:asc',
        type: postType.TYPE_NEWS
      },
      priorityDialogData: {
        message: null,
        id: null,
        order: null,
        // for reassigning if priority assignment dialog is cancelled
        oldOrder: null
      },
      showDeleteDialog: false,
      loading: false,
      cardLoading: false

    }
  },
  mounted () {
    this.priorityDialogData.oldOrder = this.post.order
    this.priorityParams.id = this.post.id
    this.priorityParams.category_id = this.post.category.id
    this.priorityParams.publish_date = this.post.publish_date
    this.priorityParams.oldOrder = this.post.order
    this.oldOrder = this.post.order
  },
  computed: {

    publishDate () {
      return this.$moment(this.post.publish_date).format(dateFormats.DDMMYY)
    }
  },
  methods: {
    closePriorityDialog (data) {
      this.showPriorityDialog = false
      if (data !== undefined) {
        // assigned old order since dialog has been cancelled
        this.post.order = data.oldOrder
      }
    },
    priorityChangeConfirmed (data) {
      // when confirm button is clicked
      this.$log.info('priority change confirmed ', [data])
      this.$emit('priorityChanged', { id: this.post.id, priority: parseInt(this.post.order) })
    },
    async onPriorityChange (e) {
      this.$log.info('on priority change', [this.post.order])
      if (this.post.order === '') {
        snackbar.show('Enter a valid priority value', 'error')
        return
      }
      this.priorityParams.order = this.post.order
      this.cardLoading = true
      try {
        const response = await postApi.assignOrderPriority(this.priorityParams)
        this.$log.info('Response assign priority', [response.data])
        if (response.data !== undefined) {
          if (response.data.status === 'success') {
            snackbar.show('Priority changed successfully', 'success')
            this.$emit('priorityChanged')
          } else if (response.data.status === 'fail') {
            this.priorityDialogData.message = response.data.error_message
            this.showPriorityDialog = true
            this.post.order = this.oldOrder
          }
        }
      } finally {
        this.cardLoading = false
      }
    },
    async deletingImageCallback (data) {
      if (data != null && data.id !== undefined && data.type !== undefined) {
        try {
          this.loading = true

          var r = await breakingNewsApi.delete(data.id)
          if (r.data === 'success') {
            snackbar.show('Breaking news deleted successfully', 'success')
            this.$emit('deleted')
          }
        } finally {
          this.loading = false
        }
      }
    },
    editNews () {
      this.$router.push({ path: '/breaking-news/edit/' + this.post.id, params: { news: this.post, id: this.post.id } })
    },
    parseBody (news) {
      const k = news
      if (k.body !== undefined) {
        // trim
        return k.body.substring(0, Math.min(100, k.body.length))
      }
      return ''
    },
    getSingleImage (news) {
      if (news.images !== undefined && Array.isArray(news.images) && news.images.length > 0) {
        var p = urlUtils.getImageUrl(news.images[0].path)
        return p
      }
      return ''
    }
  }

}
</script>
<style scoped>
.headerClass{
    white-space: nowrap ;
    word-break: normal;
    overflow: hidden ;
    text-overflow: ellipsis;
}
.title-bg{
  background-color: rgba(0, 0, 0, 0.53);
}
.v-text-field{
  width: 120px;
}

</style>
